import {
  __spreadProps,
  __spreadValues
} from "./chunk-N3ETBM74.js";

// src/index.ts
import { after } from "next/server.js";
var BetterErrors = class {
  constructor(url, options) {
    this.onRequestError = (error, request, nextContext) => {
      try {
        this.capture(error, { request, nextContext });
      } catch (e) {
      }
    };
    this.url = url;
    this.options = options || { isEnabled: true };
  }
  setUser(user) {
    this.user = user;
  }
  sendError(data) {
    try {
      if (!this.options.isEnabled) return;
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(__spreadProps(__spreadValues({}, data), { user: this.user }))
      };
      if (typeof window === "undefined") {
        after(fetch(this.url, options).catch());
      } else {
        void fetch(this.url, options).catch();
      }
    } catch (error) {
      console.error(error);
    }
  }
  getBrowserInfo() {
    if (typeof window === "undefined") return {};
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const url = window.location.href;
    const searchParams = window.location.search;
    const referrer = document.referrer;
    const screenSize = {
      width: window.screen.width,
      height: window.screen.height,
      availWidth: window.screen.availWidth,
      availHeight: window.screen.availHeight,
      colorDepth: window.screen.colorDepth,
      pixelDepth: window.screen.pixelDepth
    };
    const viewport = { width: window.innerWidth, height: window.innerHeight };
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const cookiesEnabled = navigator.cookieEnabled;
    return { userAgent, language, url, referrer, screenSize, viewport, timeZone, cookiesEnabled, searchParams };
  }
  capture(error, context) {
    var _a, _b, _c;
    let errorName;
    let errorMessage;
    let errorStack;
    let errorCode;
    let customErrorProperties;
    if (error instanceof Error) {
      errorMessage = error.message || String(error);
      errorStack = error.stack;
      const code = error.code || error.statusCode || error.status;
      errorCode = code ? String(code) : void 0;
      if (error.name) {
        errorName = error.name;
      } else if ((_a = error.constructor) == null ? void 0 : _a.name) {
        errorName = error.constructor.name;
      } else {
        errorName = "Error";
      }
      const standardErrorKeys = /* @__PURE__ */ new Set(["name", "message", "stack", "code", "statusCode", "status"]);
      const extractedCustomProps = {};
      for (const key in error) {
        if (Object.prototype.hasOwnProperty.call(error, key) && !standardErrorKeys.has(key)) {
          extractedCustomProps[key] = error[key];
        }
      }
      if (Object.keys(extractedCustomProps).length > 0) {
        customErrorProperties = extractedCustomProps;
      }
    } else {
      errorName = "NonErrorThrown";
      errorMessage = typeof error === "string" ? error : JSON.stringify(error);
      errorStack = void 0;
      if (typeof error === "object" && error !== null) {
        const code = error.code || error.statusCode || error.status;
        errorCode = code ? String(code) : void 0;
      } else {
        errorCode = void 0;
      }
      customErrorProperties = void 0;
    }
    if ((errorMessage === "Load failed" || errorMessage === "Failed to fetch") && errorName === "TypeError") return;
    const browserInfo = this.getBrowserInfo();
    const path = typeof window !== "undefined" ? window.location.pathname : ((_b = context == null ? void 0 : context.request) == null ? void 0 : _b.path) || ((_c = context == null ? void 0 : context.nextContext) == null ? void 0 : _c.routePath);
    const errorType = typeof window !== "undefined" ? "client" : "server";
    const errorData = {
      errorName,
      errorType,
      errorMessage,
      errorStack,
      errorCode,
      errorPath: path,
      browserInfo,
      extras: context == null ? void 0 : context.extras,
      metadata: {
        nextContext: context == null ? void 0 : context.nextContext,
        request: context == null ? void 0 : context.request,
        customErrorProperties,
        caughtValue: error instanceof Error ? void 0 : error
      }
    };
    this.sendError(errorData);
  }
  captureUnhandledRejection(reason) {
    this.capture(reason, { extras: { unhandledRejection: true } });
  }
  initClient() {
    if (typeof window === "undefined") return;
    window.addEventListener("error", (event) => {
      try {
        this.capture(event.error);
      } catch (e) {
      }
    });
    window.addEventListener("unhandledrejection", (event) => {
      try {
        this.captureUnhandledRejection(event.reason);
      } catch (e) {
      }
    });
  }
};
export {
  BetterErrors
};
